export const SITE_ORIGIN = 'https://managedsite.net';

export const pageMeta = {
  '/': {
    title: 'ManagedSite.net | Website, Email, Hosting and Technical Support',
    description:
      'ManagedSite.net provides website management, web design, business email support, managed hosting, security, technical support, agency services, and technology consulting.'
  },
  '/about': {
    title: 'About | ManagedSite.net',
    description:
      'ManagedSite.net is a technical partner for websites, email, hosting, and support. Agencies and businesses can both start here.'
  },
  '/who-we-help': {
    title: 'Who We Help | ManagedSite.net',
    description:
      'How ManagedSite.net takes on website, email, and hosting work for small businesses and agencies. Request a Digital Review.'
  },
  '/contact': {
    title: 'Contact | ManagedSite.net',
    description: 'Contact Dave at ManagedSite.net. Email contact@managedsite.net.'
  },
  '/digital-review': {
    title: 'Digital Review | ManagedSite.net',
    description:
      'Send the website. Dave looks at the site, email, and hosting, then replies with what is going on.'
  },
  '/get-started': {
    title: 'Get Started | ManagedSite.net',
    description:
      'Start monthly website care, technical support, or server management. Send the URL. Dave confirms the fit and the quote.'
  },
  '/services': {
    title: 'Services | ManagedSite.net',
    description:
      'Website management, design, email, hosting, security, and technical support for businesses and agencies. Start with a Digital Review.'
  },
  '/services/website-management': {
    title: 'Website Management Services | ManagedSite.net',
    description:
      'ManagedSite.net provides WordPress maintenance, security, backups, monitoring, performance support and technical website management for businesses and agencies.'
  },
  '/services/technical-support': {
    title: 'Technical Support Services | ManagedSite.net',
    description:
      'ManagedSite.net provides technical support for websites, DNS, SSL, hosting, server management, email delivery, prepaid support blocks and urgent issues — for businesses and agencies.'
  },
  '/services/business-email': {
    title: 'Business Email Services | ManagedSite.net',
    description:
      'ManagedSite.net helps with Microsoft 365, Google Workspace, email migrations, SPF DKIM DMARC, deliverability and website transactional email reliability.'
  },
  '/services/managed-hosting': {
    title: 'Managed Hosting Services | ManagedSite.net',
    description:
      'ManagedSite.net provides managed hosting coordinated with website management, security, backups, monitoring and technical support.'
  },
  '/services/web-design-and-development': {
    title: 'Web Design and Development | ManagedSite.net',
    description:
      'ManagedSite.net provides web design and development support, including WordPress builds, redesigns, landing pages, WooCommerce projects, migrations and technical website improvements.'
  },
  '/services/technology-consulting': {
    title: 'Technology Consulting | ManagedSite.net',
    description:
      'ManagedSite.net provides technology consulting, including technology planning, vendor evaluation, platform selection, hosting reviews, security planning and digital operations guidance.'
  },
  '/agency-services': {
    title: 'Agency Services | ManagedSite.net',
    description:
      'ManagedSite.net provides white-label website management, technical support, agency hosting, email support, project delivery and technology consulting for agencies.'
  },
  '/agency-services/white-label-wordpress': {
    title: 'White-Label WordPress Management | ManagedSite.net',
    description:
      'White-label WordPress management for agencies. Your agency keeps the client relationship while ManagedSite.net handles updates, security, backups, monitoring, and reporting behind your brand.'
  },
  '/agency-services/white-label-support': {
    title: 'White-Label Technical Support | ManagedSite.net',
    description:
      'White-label technical support for agencies. Your agency keeps the client relationship while ManagedSite.net handles troubleshooting, infrastructure help, and overflow work behind your brand.'
  },
  '/agency-services/agency-hosting': {
    title: 'Agency Hosting | ManagedSite.net',
    description:
      'Hosting for agencies, run by the same team that manages the website. Your agency stays the client-facing provider. Partner rates are confirmed during onboarding.'
  },
  '/agency-plans': {
    title: 'Agency White-Label Plans | ManagedSite.net',
    description:
      'White-label WordPress care for agencies. Essential, Managed, and Advanced plans starting at $59 a month. You keep the client relationship.'
  },
  '/support': {
    title: 'Support | ManagedSite.net',
    description: 'Get support from ManagedSite.net for website issues, technical requests and service questions.'
  },
  '/privacy': {
    title: 'Privacy Policy | ManagedSite.net',
    description:
      'Read the ManagedSite.net privacy policy covering website inquiries, contact form submissions, service communications and basic site usage information.'
  },
  '/terms': {
    title: 'Terms of Service | ManagedSite.net',
    description:
      'Read the ManagedSite.net terms of service covering website use, agency service inquiries and general conditions for using this site.'
  }
};

export const notFoundMeta = {
  title: 'Page not found | ManagedSite.net',
  description: 'That page is not on ManagedSite.net.',
  robots: 'noindex,follow'
};

export function pageUrl(pathname) {
  if (!pathname || pathname === '/') return `${SITE_ORIGIN}/`;
  return `${SITE_ORIGIN}${pathname}`;
}
